import React from 'react'
import Button from './Button'

function Controller({ onNextClick }) {
  return (
    <div className="controller">
      <Button type="up" onNextClick={onNextClick} />
      <Button type="down" onNextClick={onNextClick} />
    </div>
  )
}

export default Controller
